<template>
  <div id="home">
    <div id="fleet-selector">
      <select-fleet></select-fleet>
    </div>
    <expandable :title="$t('home-container.vehicleInCharge')" height="225px">
      <div
        v-for="transaction in transactions"
        :key="transaction.carID"
        :id="transaction.carID"
        class="vehicules-in-charge"
      >
        <h3>{{ transaction.borneName }}</h3>
        <img
          v-if="transaction.bornStatus === 'DISCONNECTED'"
          class="bornes"
          src="../assets/borne-disconnect.png"
          alt="Bornes de recharge"
        />
        <img
          v-else
          class="bornes"
          src="../assets/borne.png"
          alt="Bornes de recharge"
        />
        <img
          @click="goToPlanning(transaction.carID)"
          v-if="!transaction.carName"
          class="carInactive"
          src="../assets/picto-EV 1.svg"
          alt="véhicules en charge hors flotte"
        />
        <div
          v-if="transaction.carName"
          :class="{ active3: transaction.isBoosted }"
          class="hover-container"
        >
          <img
            @click="goToPlanning(transaction.carID)"
            v-if="transaction.carName"
            :class="{ active2: transaction.isBoosted }"
            class="car"
            :src="background(transaction.isBoosted)"
            alt="véhicules en charge"
          />
          <span
            @click="goToPlanning(transaction.carID)"
            :class="{ active2: transaction.isBoosted }"
            class="carMarks"
          >
            {{ transaction.carName }}
          </span>
          <div id="soc-requirement-text">
            <span class="batteryStatus">
              {{ transaction.message }}
            </span>
          </div>
          <boost-button
            :v-if="transaction.instantCharging"
            class="boost-btn"
            :idTransaction="transaction.transactionID"
            :idVehicle="transaction.carID"
            :activated="transaction.isBoosted"
            :disable="transaction.bornStatus == 'DISCONNECTED'"
          ></boost-button>
        </div>
      </div>
      <div v-if="transactions.length === 0">
        <p>{{ $t('home-container.noVehiculeAvailable') }}</p>
      </div>
    </expandable>

    <expandable :title="$t('home-container.vehicleCharged')" height="90px">
      <div v-if="vehiclefilter.length === 0">
        <p>{{ $t('home-container.noChargerAvailable') }}</p>
      </div>
      <div
        class="vehiculesCharged hover-container"
        v-for="vehicle in vehiclefilter"
        :key="vehicle.id"
        @click="goToPlanning(vehicle.id)"
      >
        <img
          class="car"
          src="../assets/Unplugged car.svg"
          alt="véhicules chargés"
        />
        <span class="carMarks">
          {{ vehicle.name }}
        </span>
      </div>
    </expandable>

    <expandable :title="$t('home-container.freeEvses')" height="110px">
      <div v-if="evsefilter.length === 0">
        <p>{{ $t('home-container.noEvseAvailable') }}</p>
      </div>
      <div class="freeBornes" v-for="evse in evsefilter" :key="evse.id">
        <h3>{{ evse.name }}</h3>
        <img
          v-if="evse.status == 'DISCONNECTED'"
          class="bornesFree"
          src="../assets/borne-disconnect.png"
          alt="Bornes de recharge"
        />
        <img
          v-else
          class="bornesFree"
          src="../assets/borne.png"
          alt="Bornes de recharge"
        />
      </div>
    </expandable>
  </div>
</template>

<script>
import SelectFleet from '../components/select-fleet'
import BoostButton from '../components/boost-button'
import expandable from '../components/expandable-container'
import moment from 'moment-timezone'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    BoostButton,
    SelectFleet,
    expandable
  },
  name: 'Home',
  data () {
    return {
      hover: false,
      boost: false
    }
  },
  created () {
    this.startInterval()
  },
  updated () {
    if (this.$route.name === 'Home') {
      this.redirectIfFleetIdExists()
    }
  },
  computed: {
    ...mapState(['vehicles', 'evses']),
    ...mapGetters('vehicle', ['getFleets', 'getVehicles', 'getEvses', 'getFleetId', 'getCurrentVehicle']),
    transactions () {
      const carsInCharge = this.getVehicles.filter(vehicle => vehicle.currentTransaction)
      const evsesOccupied = this.getEvses.filter(evse => evse.currentTransaction)
      var transactions = []
      var unKnownTransactions = []
      evsesOccupied.forEach(evse => {
        const cars = carsInCharge.filter(vehicle => vehicle.currentTransaction.id === evse.currentTransaction.id)
        if (cars.length > 0) {
          const car = cars[0]
          var message = this.getSocRequirementMessage(car.nextSocRequirement)
          transactions.push({
            carID: car.id,
            carName: car.name,
            transactionID: car.currentTransaction.id,
            instantCharging: car.availableOperations.instantCharging,
            bornStatus: evse.status,
            borneID: evse.id,
            borneName: evse.name,
            message,
            isBoosted: car.status === 'INSTANT_CHARGING'
          })
        } else {
          unKnownTransactions.push({
            borneID: evse.id,
            borneName: evse.name,
            bornStatus: evse.status
          })
        }
      })

      transactions.sort((a, b) => a.borneName.localeCompare(b.borneName))
      return [...transactions, ...unKnownTransactions]
    },
    vehiclefilter () {
      return this.getVehicles.filter(vehicle => vehicle.pluggedIn === false)
        .sort((a, b) => a - b)
    },
    evsefilter () {
      return this.getEvses.filter(evse => !evse.currentTransaction)
        .sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  methods: {
    ...mapActions('vehicle', ['setVehicle', 'selectFleetById', 'updateFleetsAndEvses']),
    background (isBoosted) {
      return isBoosted === false
        ? require('../assets/picto-EV 3.svg')
        : require('../assets/picto-EV 2.svg')
    },
    startInterval: function () {
      setInterval(() => {
        return this.updateFleetsAndEvses()
      }, 900000)
    },
    redirectIfFleetIdExists () {
      if (this.getFleetId) {
        this.$router.push(`/fleets/${this.getFleetId}`)
      }
    },
    goToPlanning (vehicleId) {
      this.getVehicles.forEach(vehicle => {
        if (vehicle.id === vehicleId) {
          this.setVehicle(vehicle)
          this.$router.push(`/fleets/${this.getFleetId}/Planning`)
        }
      })
    },
    getSocRequirementMessage (socRequirement) {
      if (socRequirement) {
        var today = moment().tz(this.getCurrentVehicle.timezone)
        var socDate = moment(socRequirement.startsAt).tz(this.getCurrentVehicle.timezone)

        if (today.format('YYYYMMDD') === socDate.format('YYYYMMDD') && today.isBefore(socDate)) {
          return `${socRequirement.soc}% ${this.$t('home-container.at')} ${socDate.format('HH')}h${socDate.format('mm')}`
        }
        return `${socRequirement.soc}% ${this.$t('home-container.tomorrow')} ${this.$t('home-container.at')} ${socDate.format('hh')}h${socDate.format('mm')}`
      }
      return ''
    }
  }
}
</script>

<style scoped>
.active3 {
  color: #fe5815;
}

h2 {
  color: #10367a;
  font-size: 18px;
  font-weight: 700;
  width: 100%;
  text-transform: uppercase;
  text-align: left;
}

#fleet-selector {
  width: 250px;
}

#home {
  margin-left: 98px;
  margin-right: 98px;
}

.boost-btn {
  margin: 5px auto;
  margin-bottom: 20px;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

h3 {
  color: #10367a;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.vehicules,
.freeBornes,
.vehiculesCharged {
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 20px;
  display: inline-block;
  text-align: center;
  min-height: 100px;
}

.vehiculesCharged {
  width: 120px;
}

.freeBornes {
  align-items: center;
  width: 120px;
}

.vehicules {
  width: 130px;
  height: 265px;
}

.vehicules-in-charge {
  margin-top: 10px;
  margin-left: 0px;
  margin-right: 0px;
  width: 177px;
  text-align: center;
  height: 215px;
  overflow: hidden;
  text-overflow: ellipsis;
}

img.bornes {
  height: 75px;
  width: 70px;
  display: block;
  margin: auto;
  margin-top: -5px;
  margin-bottom: -20px;
  margin-left: 60px;
}

img.bornesFree {
  height: 80px;
  width: 75px;
  display: block;
  margin: 0px auto;
}

img.car {
  height: 70px;
  margin: -10px auto;
  display: block;
  cursor: pointer;
}

img.carInactive {
  width: 95px;
  height: 78px;
}

#soc-requirement-text {
  height: 24px;
}

.hover-container:hover img.car {
  filter: drop-shadow(-2px -2px 5px #10367a);
}

.hover-container:hover span.carMarks {
  font-weight: bold;
  color: #10367a;
  text-decoration: underline #10367a;
  cursor: pointer;
}

.hover-container:hover img.car.active2 {
  filter: drop-shadow(-2px -2px 5px #fe5815);
}

.hover-container:hover span.carMarks.active2 {
  font-weight: bold;
  color: #fe5815;
  text-decoration: underline #fe5815;
}

img.carCharged {
  height: 78px;
  width: 100px;
  margin-bottom: -15px;
}

span.carMarks {
  display: block;
  margin-top: 3px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

span.batteryStatus {
  margin-top: 5px;
  font-style: italic;
}

a.showMore {
  text-decoration: underline;
  float: right;
}

.show-more-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
